import React from "react";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { MobileSignRequestStyles } from "../MobileSignRequest.styles";
import { pressableProps } from "../mobileA11y";

interface MobileBottomBarProps {
  leftLabel?: string;
  leftIcon?: React.ReactNode;
  leftTrailingIcon?: React.ReactNode;
  onLeftClick?: (e: React.MouseEvent<HTMLElement>) => void;
  rightLabel: string;
  onRightClick: () => void;
  rightDisabled?: boolean;
}

const MobileBottomBar: React.FC<MobileBottomBarProps> = ({
  leftLabel,
  leftIcon,
  leftTrailingIcon,
  onLeftClick,
  rightLabel,
  onRightClick,
  rightDisabled,
}) => {
  const theme = useTheme();
  const classes = MobileSignRequestStyles(theme);

  return (
    <Box sx={classes.bottomBar}>
      {leftLabel ? (
        <Box
          sx={classes.addAction}
          {...pressableProps(
            (e) => onLeftClick?.(e as React.MouseEvent<HTMLElement>),
            { hasPopup: leftTrailingIcon ? "menu" : undefined },
          )}
        >
          {leftIcon}
          <Typography component="span" sx={{ fontWeight: 600 }}>
            {leftLabel}
          </Typography>
          {leftTrailingIcon}
        </Box>
      ) : (
        <Box />
      )}

      <Button
        variant="contained"
        disableElevation
        onClick={onRightClick}
        disabled={rightDisabled}
      >
        {rightLabel}
      </Button>
    </Box>
  );
};

export default MobileBottomBar;
